import { DataSnapshot, onValue, ref } from 'firebase/database';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { auth, database } from '../api/firebase';
import useRoomcode from '../hooks/useRoomcode';
import BubbleModal from './BubbleModal';
import FormJoinBubble from './FormJoinBubble';

interface RoomFilterProps { }

const RoomFilter: React.FC<RoomFilterProps> = ({ children }) => {
  const history = useHistory();
  const uid = auth.currentUser!.uid; // guaranteed user since this is inside AuthFilter
  const roomcode = useRoomcode();
  const [isUserInRoom, setIsUserInRoom] = useState<boolean>(false);

  useEffect(() => {
    const roomcodeRef = ref(database, `bubbles/${roomcode}`);
    const unsubscribe = onValue(roomcodeRef, async (snapshot: DataSnapshot) => {
      if (!snapshot.exists()) history.push('/');
    });
    return unsubscribe;
  }, [history, roomcode]);

  useEffect(() => {
    const userInRoomRef = ref(database, `bubbles/${roomcode}/users/${uid}`);
    const unsubscribe = onValue(userInRoomRef, async (snapshot: DataSnapshot) => {
      setIsUserInRoom(snapshot.exists());
    });
    return unsubscribe;
  }, [roomcode, uid]);

  return <>{isUserInRoom ? children : (
    <BubbleModal
      isOpen
      closeModal={() => null}
      contentLabel='join bubble'
      children={<FormJoinBubble requestedRoomcode={roomcode} />}
    />)}
  </>;
};

export default RoomFilter;
